<template>
    <div class="pages view">
        <PagesNav @click_nav="pageRouter"/>
        <ProjectsCMS 
            v-if="currentPage === 'projects'"
            :titel="'Alle Projecten'"
            :zoek="'Zoek een project'"
            :button="true"
        />
        <NieuwsCMS 
            v-if="currentPage === 'nieuws'"
            :titel="'Alle nieuwsartikelen'"
            :zoek="'Zoek een nieuwsartikel'"
            :button="true"
        />
        <VacaturesCMS 
            v-if="currentPage === 'vacature'"
            :titel="'Alle Vacatures'"
            :zoek="'Zoek een vacature'"
            :button="true"
        />
        <OpeningCMS 
            v-if="currentPage === 'openingsuren'"
            :titel="'Bewerk Openingsuren'"
            :zoek="'opening'"
            :button="false"
        />
    </div>
</template>
<script>
import PagesNav from "../components/pages/_templates/comps/PagesNav.vue";
import ProjectsCMS from '../components/pages/ProjectsCMS.vue';
import NieuwsCMS from '../components/pages/NieuwsCMS.vue';
import VacaturesCMS from '../components/pages/VacatureCMS.vue';
import OpeningCMS from '../components/pages/OpeningCMS.vue';
export default {
    inject:['data', 'status'],
    components:{
        PagesNav,
        ProjectsCMS,
        NieuwsCMS,
        VacaturesCMS,
        OpeningCMS,
    },
    data(){
        return{
            currentPage: "nieuws"
        }
    },
    created(){
            if(this.$route.query.page == "projects"){
                sessionStorage.DevPage = "projects"
                this.currentPage = "projects"
            } else if(this.$route.query.page == "nieuws"){
                sessionStorage.DevPage = "nieuws"
                this.currentPage = "nieuws"
            }  else if(this.$route.query.page == "vacature"){
                sessionStorage.DevPage = "vacature"
                this.currentPage = "vacature"
            }  else if(this.$route.query.page == "openingsuren"){
                sessionStorage.DevPage = "openingsuren"
                this.currentPage = "openingsuren"
            }

    },  
    methods:{
        pageRouter(page){
            this.currentPage = page;
        }
    }
}
</script>